import "./payment.css";
import { useHistory } from "react-router-dom";
import { PayHeader } from "../Paymentheader/PayHeader";
// import { useSelector } from "react-redux";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import { useSelector, useDispatch } from "react-redux";
import {
  Payment_Request,
  SelectedRoute,
} from "../../Redux/actions/NumBikeation";
import { message, Checkbox, Modal } from "antd";
import { useState } from "react";
import moment from "moment";
import Terms from "./Terms";

export const PaymentDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [isCheckedNext, setIsCheckedNext] = useState(false);
  const [error, setError] = useState("");
  const SQQData = useSelector((state) => state?.common?.selectedQuote);
  const store = useSelector((state) => state.addressdetail.info2);
  const engine = useSelector((state) => state.addressdetail.info3);
  const vechicledetails = useSelector(
    (state) => state.vehicledetail.bikeMakeData
  );
  const bikeInurId = useSelector((state) => state?.vehicledetail?.bikenum);
  const proposal = useSelector(
    (state) => state?.vehicledetail?.createProposal?.data
  );
  const KYCData = useSelector((state) => state.vehicledetail.KycStatus);
  const { varcar, make, model, year } = vechicledetails;
  const [ModalOpen, setModalOpen] = useState(false);
  // console.log("proposal data", SQQData);

  const OnModelOpen = () => {
    setModalOpen(true);
  };
  const OnModelClose = () => {
    setModalOpen(false);
  };
  const handleRoute = () => {
    setIsLoading(true);
    if (!isCheckedNext) {
      setError("Please agree to the Terms & Conditions");
      setIsLoading(false);
      return;
    } else {
      setError("");
      let post = {
        insurance_id: bikeInurId?.bike_insurance_id,
        applicationId: proposal?.applicationId,
      };
      // v2/bike_insurances/{insurance}/insurers/{insurer}/payment_request
      console.log(post);
      axiosInstance
        .post(
          `v2/bike_insurances/${bikeInurId?.bike_insurance_id}/insurers/${SQQData?.provider}/payment_request`,
          post
        )
        .then((res) => {
          console.log("Final Proposal", res);
          setIsLoading(false);
          if (res?.data?.data?.status === "success") {
            if (SQQData?.provider === "go_digit") {
              dispatch(SelectedRoute("digit/bike_insurance"));
              history.push("/credit");
              let Paydata = {
                data: res.data.data,
                post: post,
              };
              console.log(Paydata);
              console.log(Paydata?.data?.dispatcherResponse);
              window.open(Paydata?.data?.dispatcherResponse, "_blank");
              dispatch(Payment_Request(Paydata));
            } else {
              // history.push("/IciciCredit/");
              const IcicPay = {
                data: res?.data?.data,
                post: post,
              };
              console.log(IcicPay);
              window.open(IcicPay?.data?.payment_url, "_blank");
              dispatch(SelectedRoute("icici/bike_insurance"));
              dispatch(Payment_Request(IcicPay));
            }
          }
        })
        .catch((err) => {
          console.log(err.response);
          message.error(err?.response?.data?.message);
          setIsLoading(false);
        });
    }
  };

  return (
    <div className="pay_body">
      <PayHeader />
      <div className="payment-md-page row justify-content-around">
        <div className="personal-md-details col-12 col-lg-6 col-xs-12 col-sm-12 col-md-4">
          <div className="per-d1-md">
            <div></div>
            <h5
              style={{
                marginLeft: "16px",
                paddingTop: "5px",
                fontSize: "22px",
              }}
            >
              Summary
            </h5>
          </div>
          <div className="Pd-md">
            <div>Personal Details</div>
          </div>
          <div className="owner-md-de">
            <div>
              <p className="p1-md" style={{ marginLeft: "1px" }}>
                Name of the vehical owner
              </p>
              <p className="p2-md">{store?.Owner}</p>

              <p
                className="p1-md"
                style={{ marginLeft: "1px", marginTop: "15px" }}
              >
                Communication Address
              </p>

              <p className="p2-md">{store?.Address}</p>
              <p className="p3-md">
                {store?.City}, {store?.State}-{store?.Pincode}
              </p>
              <p
                className="p3-md"
                style={{ marginLeft: "1px", width: "110px" }}
              >
                {store?.State}
              </p>
              <p
                className="p1-md"
                style={{ marginTop: "15px", marginLeft: "1px", width: "110px" }}
              >
                Email Address
              </p>
              <p
                className="p3-md"
                style={{ marginLeft: "1px", width: "220px" }}
              >
                {store?.Email}
              </p>
              <p
                className="p1-md"
                style={{ marginLeft: "1px", marginTop: "15px", width: "108px" }}
              >
                Mobile No.
              </p>
              <p className="p3-md" style={{ width: "45px", marginLeft: "1px" }}>
                {store?.Mobile}
              </p>
            </div>
            <div>
              <p className="p1-md" style={{ marginLeft: "20px" }}>
                Name of the Nominee
              </p>
              <p
                className="p2-md"
                style={{ width: "45px", marginLeft: "20px" }}
              >
                {store?.Nname}
              </p>
              <p
                className="p1-md"
                style={{ marginTop: "15px", width: "45px", marginLeft: "20px" }}
              >
                Nominee Relationship
              </p>
              <p
                className="p2-md"
                style={{ width: "45px", marginLeft: "20px" }}
              >
                {store?.Nrelation}
              </p>
              <p
                className="p1-md"
                style={{
                  marginTop: "25px",
                  width: "110px",
                  marginLeft: "20px",
                }}
              >
                Nominee Age
              </p>
              <p
                className="p2-md"
                style={{ width: "45px", marginLeft: "20px" }}
              >
                {store?.Nage}
              </p>
            </div>
          </div>
          <div className="Pd-md-1">
            <div>Vehicle and Policy details</div>
          </div>
          <div className="vehicle-md-d">
            <div>
              <p
                className="p1-md"
                style={{ width: "150px", marginLeft: "1px" }}
              >
                Engine Type
              </p>
              <p
                className="p2-md"
                style={{
                  width: "110px",
                  marginLeft: "1px",
                  marginBottom: "14px",
                }}
              >
                Fuel
              </p>
              <p
                className="p2-md"
                style={{
                  width: "110px",
                  marginLeft: "1px",
                  marginBottom: "14px",
                }}
              >
                {SQQData?.vehicle?.licensePlateNumber}
              </p>

              <p
                className="p1-md"
                style={{ width: "160px", marginLeft: "1px" }}
              >
                Model & Variant Name
              </p>
              <p
                className="p2-md"
                style={{
                  width: "100px",
                  marginLeft: "1px",
                  marginBottom: "14px",
                }}
              >
                {make} {model} {varcar}
              </p>
              <p
                className="p1-md"
                style={{ width: "110px", marginLeft: "1px" }}
              >
                Registration Date
              </p>
              <p
                className="p2-md"
                style={{ width: "96px", marginBottom: "14px" }}
              >
                {SQQData?.vehicle?.registrationDate}
              </p>
              <p className="p1-md" style={{ width: "50px", marginLeft: "1px" }}>
                NCB
              </p>
              <p
                className="p2-md"
                style={{ width: "50px", marginBottom: "14px" }}
              >
                {SQQData?.contract?.currentNoClaimBonus}
              </p>
            </div>
            <div>
              <p
                className="p1-md"
                style={{ width: "150px", marginLeft: "12px" }}
              >
                Add-Ons in Policy
              </p>
              <p
                className="p2-md"
                style={{
                  width: "110px",
                  marginLeft: "12px",
                  marginBottom: "14px",
                }}
              >
                Not Included{" "}
              </p>
              <p
                className="p1-md"
                style={{ width: "110px", marginLeft: "12px" }}
              >
                Engine Number
              </p>
              <p
                className="p2-md"
                style={{
                  width: "110px",
                  marginLeft: "12px",
                  marginBottom: "14px",
                }}
              >
                {engine?.Engine}
              </p>
              <p
                className="p1-md"
                style={{ width: "110px", marginLeft: "12px" }}
              >
                Chassis Number
              </p>
              <p
                className="p2-md"
                style={{
                  width: "110px",
                  marginLeft: "12px",
                  marginBottom: "14px",
                }}
              >
                {engine?.Chasis}
              </p>
              <p
                className="p1-md"
                style={{ width: "150px", marginLeft: "12px" }}
              >
                Manufacture Name
              </p>
              <p
                className="p2-md"
                style={{
                  width: "68px",
                  marginLeft: "12px",
                  marginBottom: "14px",
                }}
              >
                {make}
              </p>
            </div>
          </div>
          <div className="warning-md">
            <div>
              This is based on your declaration that previous NCB is 50%.
            </div>
            <div>and no claim has been made in previous policy</div>
          </div>
        </div>
        <div className="pay-md-security px-0 col-12 col-lg-5 col-xs-12 col-sm-12 col-md-4">
          <div className="pay-md-head">
            <p style={{ margin: "0" }}>
              Your new policy will start from{" "}
              {moment(new Date()).format("MM-DD-YYYY")}
            </p>
          </div>
          <div className="d-flex px-3 py-3 row align-items-center row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1">
            <div className="py-2 px-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
              <img
                style={{ width: "75%" }}
                src={SQQData?.logo}
                alt="company name"
              />
            </div>
            <div className="px-0 col-xl-5 col-lg-4 col-md-6 col-sm-6 col-6">
              <div
                //className="p1-md"
                style={{ marginBottom: "8px" }}
              >
                IDV (Insured declare value)
              </div>
              {/* <div
               
              >
                NCB (No claim bonus)
              </div> */}
            </div>
            <div className="px-0 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-6">
              <div style={{ marginBottom: "8px" }}>
                ₹ {SQQData?.vehicle?.vehicleIDV?.idv}
              </div>
              <div>
                {SQQData?.contract?.currentNoClaimBonus === "ZERO"
                  ? "0%"
                  : SQQData?.contract?.currentNoClaimBonus}
              </div>
            </div>
          </div>
          <div className="total-md-am1">
            <div>
              <p>NET PREMIUM</p>
              <p style={{ width: "25px" }}>GST</p>
            </div>
            <div>
              <p>
                ₹{" "}
                {typeof proposal?.netPremium === "string"
                  ? Math.round(
                      parseFloat(proposal?.netPremium.replace(/[^\d.]/g, ""))
                    )
                  : proposal?.netPremium}
              </p>
              <p>
                + ₹{" "}
                {typeof proposal?.serviceTax?.totalTax === "string"
                  ? Math.round(
                      parseFloat(
                        proposal?.serviceTax?.totalTax.replace(/[^\d.]/g, "")
                      )
                    )
                  : proposal?.serviceTax?.totalTax}
              </p>
            </div>
          </div>
          <div className="total-md-am3">
            <div className="total-md-am44">
              <p>You Pay</p>
              <p>
                ₹{" "}
                {typeof proposal?.grossPremium === "string"
                  ? Math.round(
                      parseFloat(proposal?.grossPremium.replace(/[^\d.]/g, ""))
                    )
                  : proposal?.grossPremium}
              </p>
            </div>
            {/* <div className="input-md-2">
              <Checkbox>Get's update on Whatsapp</Checkbox>
            </div> */}
            <div className="d-flex align-items-center gap-1 mb-2 mx-2">
              <Checkbox
                onChange={(e) => setIsCheckedNext(e.target.checked)}
              ></Checkbox>
              I agree to the{" "}
              <span
                style={{ color: "#0663F6", cursor: "pointer" }}
                onClick={OnModelOpen}
              >
                Terms & Conditions
              </span>
            </div>
            {isCheckedNext === false && error ? (
              <p
                style={{ color: "red", textAlign: "center", marginTop: "8px" }}
              >
                {error}
              </p>
            ) : null}
            {/* {error && <p style={{ color: 'red',textAlign: 'center',marginTop: "8px" }}>{error}</p>}  */}
          </div>
          <div className="total-md-am4">
            {/* {KYCData.message === "NOT_DONE" ?  */}
            <button
              className={`btn btn-primary btn-block w-100 ${
                isLoading ? "disabled" : ""
              }`}
              style={{
                width: "100%",
                height: "50px",
                backgroundColor: " #273592",
                border: "none",
                color: "white",
                fontSize: "18px",
                fontWeight: "500",
              }}
              onClick={handleRoute}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "PAY NOW"}
            </button>
          </div>
        </div>
      </div>
      <Modal
        className="term-modal"
        open={ModalOpen}
        footer={null}
        onCancel={OnModelClose}
        maskClosable={false}
      >
        <Terms setModalOpen={setModalOpen} />
      </Modal>
      <div className="footter-md">
        <div className="footter-md-1">
          <p>Disclaimer:</p>
          <p>
            All savings provided by insurers as per IRDAI approved insurance
            plans. Standard T&C apply.
          </p>
          <p>
            Actual time for transaction may vary subject to additional data
            requirements and operational processes.
          </p>
          <p>
            VIBE Insurance Brokers Private Limited (formerly known as VIBE
            Insurance Web Aggregator Private Limited)
          </p>
          <p>
            Registration No. 742, Registration Code No. IRDA/ DB 797/ 19, Valid
            till 09/06/2024, License category- Direct Broker (Life & General)
          </p>
          <p>
            Visitors are hereby informed that their information submitted on the
            website may be shared with insurers. Product information is
            authentic and
          </p>
          <p> solely based on the information received from the insurers.</p>
        </div>
        <div className="footer-md-2">
          <p>@Copyright 2018-2024</p>
          <p>
            <a href="www.VIBE.com">VIBE</a>
          </p>
          <p>All rights reserved</p>
        </div>
      </div>
    </div>
  );
};
